module.exports = __webpack_public_path__ + "static/media/water.f0d3b3c7.png";